/*using-turbo-ignore*/
/*customizing-behavior*/
/*using-turbo-ignore-on-vercel*/
/*customizing-behavior-1*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "跳过任务",
  "description": "永远不要重复做同样的工作。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "缓存 显著加快你的任务速度 - 但使用 npx turbo-ignore 可能会让你运行得更快。如果工作区不受代码更改的影响，你可以完全跳过执行任务。"
  }, {
    "heading": "",
    "content": "¥Caching dramatically speeds up your tasks - but you may be able to go even faster by using npx turbo-ignore. If a workspace is unaffected by your code changes, you can completely skip executing a task altogether."
  }, {
    "heading": "",
    "content": "假设你希望在 web 应用（或其包依赖）没有任何更改时跳过 web 工作区的单元测试。如果你已经在使用 远程缓存，则可能会出现缓存命中。 - 但你仍然需要花时间配置 CI 容器、安装 npm 依赖以及其他可能需要一段时间的操作。"
  }, {
    "heading": "",
    "content": "¥Let's say you want to skip the unit tests for your web workspace when there aren't any changes to your web application (or its package dependencies). If you are already using Remote Caching, you will probably get a cache hit - but you would still spend time provisioning the CI container, installing npm dependencies, and other things that can take a while."
  }, {
    "heading": "",
    "content": "理想情况下，你应该快速检查一下是否需要执行任何此类工作。"
  }, {
    "heading": "",
    "content": "¥Ideally, you would do a quick check to see if any of that work needs to happen in the first place."
  }, {
    "heading": "",
    "content": "检出代码库后，但在进行任何其他工作之前，你可以花几秒钟检查一下 web 测试自父提交以来是否发生了变化。"
  }, {
    "heading": "",
    "content": "¥After you've checked out the repo, but before any other work, you can take a few seconds to check that your web tests have changed since the parent commit."
  }, {
    "heading": "",
    "content": "此命令将："
  }, {
    "heading": "",
    "content": "¥This command will:"
  }, {
    "heading": "",
    "content": "过滤 web 工作区。"
  }, {
    "heading": "",
    "content": "¥Filter for the web workspace."
  }, {
    "heading": "",
    "content": "为你的 test 任务创建 dry 输出，并与父提交进行比较。"
  }, {
    "heading": "",
    "content": "¥Create the dry output for your test task compared to your parent commit."
  }, {
    "heading": "",
    "content": "解析输出以确定哪些软件包已更改。"
  }, {
    "heading": "",
    "content": "¥Parse the output to determine which packages have changed."
  }, {
    "heading": "",
    "content": "如果检测到更改，则使用 1 代码退出。否则，以 0 退出。"
  }, {
    "heading": "",
    "content": "¥Exit with a 1 code if changes are detected. Otherwise, exits with a 0."
  }, {
    "heading": "",
    "content": "虽然你可能已经能够为此任务访问 >>> FULL TURBO 缓存，但你只是节省了运行 CI 所需的所有其他设置任务的时间。"
  }, {
    "heading": "",
    "content": "¥While you may have been able to hit a >>> FULL TURBO cache for this task, you just saved time with all of the other setup tasks required to run your CI."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥Using turbo-ignore"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "要跳过不受影响的工作，首先请确保你的 Git 历史记录在计算机上可用。然后，运行 npx turbo-ignore。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥To skip unaffected work, first ensure that your Git history is available on the machine. Then, run npx turbo-ignore."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "turbo-ignore 结合使用 --filter 和 --dry=json 标志来查找从父提交到当前提交的更改，以识别受影响的包。默认情况下，turbo-ignore 会在当前工作目录中查找构建任务的差异，但 使用标志自定义此行为 可以。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥turbo-ignore uses a combination of the --filter and --dry=json flags to find changes from the parent commit to the current commit to identify affected packages. By default, turbo-ignore finds the difference for the build task in the current working directory, but you can customize this behavior with flags."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "以下是将要构建和运行的命令示例："
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥Here's an example of the command that will be built and run:"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "请注意，试运行不会执行构建任务。相反，它会在几秒钟内检查你的软件包，看看你的代码更改是否会影响你的构建（或其他任务）。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥Note that a dry run does not execute the build task. Instead, it checks your packages to see if your code changes will affect your build (or other task) in only a few seconds."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "如果 turbo-ignore 发现该任务可以跳过，它将退出进程并返回 0 代码。如果发现更改，该进程将退出并返回 1。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥If turbo-ignore finds that the task can be skipped, it will exit the process with a 0 code. If changes have been found, the process will exit with 1."
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "在 Vercel 上，将使用先前部署的 SHA 而不是父提交。"
  }, {
    "heading": "使用-turbo-ignore-using-turbo-ignore",
    "content": "¥On Vercel, the previously deployed SHA will be used instead of the parent\ncommit."
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥Customizing behavior"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "要指定工作区，你可以将其添加到命令中，例如："
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥To specify a workspace, you can add it to your command like:"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "其中 web 是运行默认 build 任务的工作区名称。"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥where web is your workspace's name running the default build task."
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "如果你想更改任务，请使用 --task 标志指定 turbo-ignore 将调用的命令的任务。"
  }, {
    "heading": "自定义行为-customizing-behavior",
    "content": "¥If you'd like to change the task, use the --task flag to specify the task for the command that turbo-ignore will invoke."
  }, {
    "heading": "在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
    "content": "¥Using turbo-ignore on Vercel"
  }, {
    "heading": "在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
    "content": "要在 Vercel 上使用 npx turbo-ignore，你可以使用 忽略的构建步骤 功能。Vercel 将自动推断正确的参数以成功运行 turbo-ignore。"
  }, {
    "heading": "在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
    "content": "¥To use npx turbo-ignore on Vercel, you can use the Ignored Build Step feature. Vercel will automatically infer the correct arguments to successfully run turbo-ignore."
  }, {
    "heading": "自定义行为-customizing-behavior-1",
    "content": "¥Customizing behavior"
  }, {
    "heading": "自定义行为-customizing-behavior-1",
    "content": "不在 Vercel 上时，请使用 --fallback 标志指定要比较的提交。"
  }, {
    "heading": "自定义行为-customizing-behavior-1",
    "content": "¥When not on Vercel, specify a commit for comparison using the --fallback flag."
  }, {
    "heading": "自定义行为-customizing-behavior-1",
    "content": "在 Vercel 上，你可以指定 --fallback 标志，以便在默认比较不可用时为 Vercel 提供一个 git 引用进行比较。默认情况下，Vercel 会与最近部署的 SHA 进行比较，因此这对于避免首次提交到分支的部署等用例非常有用。"
  }, {
    "heading": "自定义行为-customizing-behavior-1",
    "content": "¥On Vercel, you can specify the --fallback flag to give Vercel a git ref to compare against when the default comparison is not available. By default, Vercel compares to the most recently deployed SHA so this is useful for use cases like avoiding a deploy for the first commit to a branch."
  }],
  "headings": [{
    "id": "使用-turbo-ignore-using-turbo-ignore",
    "content": "使用 turbo-ignore /*using-turbo-ignore*/"
  }, {
    "id": "自定义行为-customizing-behavior",
    "content": "自定义行为 /*customizing-behavior*/"
  }, {
    "id": "在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
    "content": "在 Vercel 上使用 turbo-ignore /*using-turbo-ignore-on-vercel*/"
  }, {
    "id": "自定义行为-customizing-behavior-1",
    "content": "自定义行为 /*customizing-behavior-1*/"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#使用-turbo-ignore-using-turbo-ignore",
  title: _jsxs(_Fragment, {
    children: ["使用 ", _jsx("code", {
      children: "turbo-ignore"
    }), " "]
  })
}, {
  depth: 2,
  url: "#自定义行为-customizing-behavior",
  title: _jsx(_Fragment, {
    children: "自定义行为 "
  })
}, {
  depth: 2,
  url: "#在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
  title: _jsxs(_Fragment, {
    children: ["在 Vercel 上使用 ", _jsx("code", {
      children: "turbo-ignore"
    }), " "]
  })
}, {
  depth: 2,
  url: "#自定义行为-customizing-behavior-1",
  title: _jsx(_Fragment, {
    children: "自定义行为 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "缓存"
      }), " 显著加快你的任务速度 - 但使用 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), " 可能会让你运行得更快。如果工作区不受代码更改的影响，你可以完全跳过执行任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "Caching"
      }), " dramatically speeds up your tasks - but you may be able to go even faster by using ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), ". If a workspace is unaffected by your code changes, you can completely skip executing a task altogether."]
    }), "\n", _jsxs(_components.p, {
      children: ["假设你希望在 ", _jsx(_components.code, {
        children: "web"
      }), " 应用（或其包依赖）没有任何更改时跳过 ", _jsx(_components.code, {
        children: "web"
      }), " 工作区的单元测试。如果你已经在使用 ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching",
        children: "远程缓存"
      }), "，则可能会出现缓存命中。 - 但你仍然需要花时间配置 CI 容器、安装 ", _jsx(_components.code, {
        children: "npm"
      }), " 依赖以及其他可能需要一段时间的操作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Let's say you want to skip the unit tests for your ", _jsx(_components.code, {
        children: "web"
      }), " workspace when there aren't any changes to your ", _jsx(_components.code, {
        children: "web"
      }), " application (or its package dependencies). If you are already using ", _jsx(_components.a, {
        href: "https://turbo.nodejs.cn/docs/core-concepts/remote-caching",
        children: "Remote Caching"
      }), ", you will probably get a cache hit - but you would still spend time provisioning the CI container, installing ", _jsx(_components.code, {
        children: "npm"
      }), " dependencies, and other things that can take a while."]
    }), "\n", _jsx(_components.p, {
      children: "理想情况下，你应该快速检查一下是否需要执行任何此类工作。"
    }), "\n", _jsx(_components.p, {
      children: "¥Ideally, you would do a quick check to see if any of that work needs to happen in the first place."
    }), "\n", _jsx(_components.hr, {}), "\n", _jsxs(_components.p, {
      children: ["检出代码库后，但在进行任何其他工作之前，你可以花几秒钟检查一下 ", _jsx(_components.code, {
        children: "web"
      }), " 测试自父提交以来是否发生了变化。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥After you've checked out the repo, but ", _jsx(_components.strong, {
        children: "before"
      }), " any other work, you can take a few seconds to check that your ", _jsx(_components.code, {
        children: "web"
      }), " tests have changed since the parent commit."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --task=test"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "此命令将："
    }), "\n", _jsx(_components.p, {
      children: "¥This command will:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["过滤 ", _jsx(_components.code, {
            children: "web"
          }), " 工作区。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Filter for the ", _jsx(_components.code, {
            children: "web"
          }), " workspace."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["为你的 ", _jsx(_components.code, {
            children: "test"
          }), " 任务创建 ", _jsx(_components.code, {
            children: "dry"
          }), " 输出，并与父提交进行比较。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Create the ", _jsx(_components.code, {
            children: "dry"
          }), " output for your ", _jsx(_components.code, {
            children: "test"
          }), " task compared to your parent commit."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "解析输出以确定哪些软件包已更改。"
        }), "\n", _jsx(_components.p, {
          children: "¥Parse the output to determine which packages have changed."
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["如果检测到更改，则使用 ", _jsx(_components.code, {
            children: "1"
          }), " 代码退出。否则，以 ", _jsx(_components.code, {
            children: "0"
          }), " 退出。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Exit with a ", _jsx(_components.code, {
            children: "1"
          }), " code if changes are detected. Otherwise, exits with a ", _jsx(_components.code, {
            children: "0"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["虽然你可能已经能够为此任务访问 ", _jsx(_components.code, {
        children: ">>> FULL TURBO"
      }), " 缓存，但你只是节省了运行 CI 所需的所有其他设置任务的时间。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥While you may have been able to hit a ", _jsx(_components.code, {
        children: ">>> FULL TURBO"
      }), " cache for this task, you just saved time with all of the other setup tasks required to run your CI."]
    }), "\n", _jsxs(_components.h2, {
      id: "使用-turbo-ignore-using-turbo-ignore",
      children: ["使用 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "turbo-ignore"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["要跳过不受影响的工作，首先请确保你的 Git 历史记录在计算机上可用。然后，运行 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To skip unaffected work, first ensure that your Git history is available on the machine. Then, run ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo-ignore"
      }), " 结合使用 ", _jsx(_components.code, {
        children: "--filter"
      }), " 和 ", _jsx(_components.code, {
        children: "--dry=json"
      }), " 标志来查找从父提交到当前提交的更改，以识别受影响的包。默认情况下，", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 会在当前工作目录中查找构建任务的差异，但 ", _jsx(_components.a, {
        href: "#customizing-behavior",
        children: "使用标志自定义此行为"
      }), " 可以。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " uses a combination of the ", _jsx(_components.code, {
        children: "--filter"
      }), " and ", _jsx(_components.code, {
        children: "--dry=json"
      }), " flags to find changes from the parent commit to the current commit to identify affected packages. By default, ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " finds the difference for the ", _jsx(_components.strong, {
        children: "build task in the current working directory"
      }), ", but you can ", _jsx(_components.a, {
        href: "#customizing-behavior",
        children: "customize this behavior with flags"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "以下是将要构建和运行的命令示例："
    }), "\n", _jsx(_components.p, {
      children: "¥Here's an example of the command that will be built and run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@example/web...3c8387ffd98b751305fe3f0284befdd00cbd4610"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --dry=json"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "请注意，试运行不会执行构建任务。相反，它会在几秒钟内检查你的软件包，看看你的代码更改是否会影响你的构建（或其他任务）。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Note that a dry run does not ", _jsx(_components.em, {
        children: "execute"
      }), " the build task. Instead, it checks your packages to see if your code changes will affect your build (or other task) in only a few seconds."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 发现该任务可以跳过，它将退出进程并返回 ", _jsx(_components.code, {
        children: "0"
      }), " 代码。如果发现更改，该进程将退出并返回 ", _jsx(_components.code, {
        children: "1"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " finds that the task can be skipped, it will exit the process with a ", _jsx(_components.code, {
        children: "0"
      }), " code. If changes have been found, the process will exit with ", _jsx(_components.code, {
        children: "1"
      }), "."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "在 Vercel 上，将使用先前部署的 SHA 而不是父提交。"
      }), _jsx(_components.p, {
        children: "¥On Vercel, the previously deployed SHA will be used instead of the parent\ncommit."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "自定义行为-customizing-behavior",
      children: "自定义行为 "
    }), "\n", _jsx(_components.p, {
      children: "¥Customizing behavior"
    }), "\n", _jsx(_components.p, {
      children: "要指定工作区，你可以将其添加到命令中，例如："
    }), "\n", _jsx(_components.p, {
      children: "¥To specify a workspace, you can add it to your command like:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo-ignore"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["其中 ", _jsx(_components.code, {
        children: "web"
      }), " 是运行默认 ", _jsx(_components.code, {
        children: "build"
      }), " 任务的工作区名称。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥where ", _jsx(_components.code, {
        children: "web"
      }), " is your workspace's name running the default ", _jsx(_components.code, {
        children: "build"
      }), " task."]
    }), "\n", _jsxs(_components.p, {
      children: ["如果你想更改任务，请使用 ", _jsx(_components.code, {
        children: "--task"
      }), " 标志指定 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " 将调用的命令的任务。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you'd like to change the task, use the ", _jsx(_components.code, {
        children: "--task"
      }), " flag to specify the task for the command that ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " will invoke."]
    }), "\n", _jsxs(_components.h2, {
      id: "在-vercel-上使用-turbo-ignore-using-turbo-ignore-on-vercel",
      children: ["在 Vercel 上使用 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " "]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Using ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), " on Vercel"]
    }), "\n", _jsxs(_components.p, {
      children: ["要在 Vercel 上使用 ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), "，你可以使用 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/projects/overview#ignored-build-step",
        children: "忽略的构建步骤"
      }), " 功能。Vercel 将自动推断正确的参数以成功运行 ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥To use ", _jsx(_components.code, {
        children: "npx turbo-ignore"
      }), " on Vercel, you can use the ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/projects/overview#ignored-build-step",
        children: "Ignored Build Step"
      }), " feature. Vercel will automatically infer the correct arguments to successfully run ", _jsx(_components.code, {
        children: "turbo-ignore"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "自定义行为-customizing-behavior-1",
      children: "自定义行为 "
    }), "\n", _jsx(_components.p, {
      children: "¥Customizing behavior"
    }), "\n", _jsxs(_components.p, {
      children: ["不在 Vercel 上时，请使用 ", _jsx(_components.code, {
        children: "--fallback"
      }), " 标志指定要比较的提交。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥When not on Vercel, specify a commit for comparison using the ", _jsx(_components.code, {
        children: "--fallback"
      }), " flag."]
    }), "\n", _jsxs(_components.p, {
      children: ["在 Vercel 上，你可以指定 ", _jsx(_components.code, {
        children: "--fallback"
      }), " 标志，以便在默认比较不可用时为 Vercel 提供一个 git 引用进行比较。默认情况下，Vercel 会与最近部署的 SHA 进行比较，因此这对于避免首次提交到分支的部署等用例非常有用。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥On Vercel, you can specify the ", _jsx(_components.code, {
        children: "--fallback"
      }), " flag to give Vercel a git ref to compare against when the default comparison is not available. By default, Vercel compares to the most recently deployed SHA so this is useful for use cases like avoiding a deploy for the first commit to a branch."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
